import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useSharedStyles = makeStyles({
    tableDisplayContents: {
        display: 'contents',
    },
    tableDivider: {
        gridColumn: '1 / -1',
    },
    tableCell: {
        alignContent: 'center',
        height: '100%',
        minHeight: `calc(${tokens.spacingHorizontalXXXL} + ${tokens.spacingHorizontalXS})`,
        paddingInlineStart: px(0),
        paddingInlineEnd: tokens.spacingHorizontalL,
    },
    tableCellAlignRight: {
        justifyContent: 'flex-end',
    },
    tableCellSkeleton: {
        width: '100%',
    },
    tableCellSkeletonItem: {
        height: tokens.fontSizeBase500,
    },
});
